import gql from "graphql-tag";
import { RebateItemFragment } from "../fragments/rebateItem.fragment";

export const RELEASE_ONE_REBATE = gql`
  mutation ($id: String!) {
    releaseOneRebateItem(rebateItemId: $id) {
      ...RebateItem
    }
  }
  ${RebateItemFragment}
`;
